import { MutableRefObject, useCallback } from 'react';
import { useEventListener } from './useEventListener';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';

export function useOnOutsideClick(
  elements: Array<MutableRefObject<Element | null>>,
  callback: () => void
): void {
  const elementsRef = useRefWithCurrentValue(elements);
  const callbackRef = useRefWithCurrentValue(callback);

  const clickHandler = useCallback(
    (event: Event) => {
      const { target } = event;
      if (target && target instanceof Node) {
        const atLeastOneElementContainsTarget = elementsRef.current.some(
          (e) => e.current && e.current.contains(target)
        );
        if (!atLeastOneElementContainsTarget) {
          callbackRef.current();
        }
      }
    },
    [elementsRef, callbackRef]
  );

  useEventListener(document, 'click', clickHandler);
}
